import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzI18nModule } from '../i18n/nz-i18n.module';

import { NzIconModule } from '../icon';
import { NzInputModule } from '../input';
import { NzLayoutModule } from '../layout';

import { NzSearchbarNetComponent } from './nz-searchbar-net.component';

@NgModule({
  declarations: [ NzSearchbarNetComponent ],
  exports     : [ NzSearchbarNetComponent ],
  imports     : [ CommonModule, NzIconModule, NzLayoutModule, NzInputModule, FormsModule, NzI18nModule ]
})

export class NzSearchbarNetModule {
}
